import { initBlockEnterKeyForDisabledButton } from 'utilities/dom';
import { trackWishlistActions } from 'features/tealium';

import showRequestQuoteModal from '../showRequestQuoteModal';

const FooterItemView = Backbone.Marionette.ItemView.extend({
	template: false,
	ui: {
		btnGetQuote: '.btnGetQuote'
	},
	events: {
		'click @ui.btnGetQuote': 'getQuote'
	},
	initialize () {

		// bind UI manually since we're not using a template
		this.bindUIElements();
		initBlockEnterKeyForDisabledButton(this.ui.btnGetQuote[0]);

	},
	getQuote (e) {

		e.preventDefault();

		trackWishlistActions({
			eventAction: 'Click-Request-A-Quote'
		});

		showRequestQuoteModal();

	}
});

export default FooterItemView;
